import { HTMLAttributes } from 'react'

import ArchiveCard, { ArchiveCardProps } from '@/components/base/archive-card'
import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Motion from '@/components/base/motion'
import Section from '@/components/base/section'

import { archiveGridRevealAnimation } from './animations'

export type ArchiveGridProps = HTMLAttributes<HTMLElement> & {
  collection?: ArchiveCardProps[]
}

const ArchiveGrid = ({ collection, ...props }: ArchiveGridProps) => {
  return (
    <Motion animation={archiveGridRevealAnimation}>
      {(motionRef) => (
        <Section ref={motionRef} {...props}>
          <Container>
            <Grid className="gap-y-[6.4rem] md:gap-y-[9.6rem] xl:gap-y-[11.2rem]">
              {collection?.map((card, index) => (
                <ArchiveCard
                  key={index}
                  className="col-span-4 md:col-span-3 lg:col-span-4"
                  {...card}
                  data-motion-card
                />
              ))}
            </Grid>
          </Container>
        </Section>
      )}
    </Motion>
  )
}

export default ArchiveGrid
